import React from 'react';
import { useTestAB } from '@catalogo/core-experiments';
import { TWithDiscountProgressiveExperiment } from '../helpers/discount-progressive-expetiment';

export const withDiscountProgressiveExperiment: TWithDiscountProgressiveExperiment = Component => props => {
  let discountProgressive = props?.product?.skus?.[0]?.offers?.result?.[0]?.nextProgressiveDiscount;

  if (!discountProgressive) {
    discountProgressive = props.productCache?.currentSku?.offers?.result?.[0]?.nextProgressiveDiscount;
  }

  const quantityForDiscount = discountProgressive?.quantity;
  const priceUnit = discountProgressive?.unit;

  let experiment;

  if (quantityForDiscount && priceUnit) {
    experiment = useTestAB('EXP_CAT_034_DISCOUNT_PROGRESSIVE');
  }

  return <Component {...props} discountProgressiveExperiment={experiment} />;
};

export default withDiscountProgressiveExperiment;
